var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gfu-creator-testimonial" }, [
    _c("div", { staticClass: "gfu-creator-testimonial__side" }, [
      _c("img", {
        staticClass: "gfu-creator-testimonial__image",
        attrs: { src: _vm.imageUrl, alt: _vm.company },
      }),
      _vm._v(" "),
      _c("div", [
        _c("h4", { staticClass: "gfu-hd gfu-hd--h4 _tc--white" }, [
          _vm._v(_vm._s(_vm.creator)),
        ]),
        _vm._v(" "),
        _c(
          "h4",
          { staticClass: "gfu-hd gfu-hd--h4 _tc--white _tc--mute _fw-n" },
          [_vm._v(_vm._s(_vm.company))]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { class: ["gfu-creator-testimonial__content"] }, [
      _vm._v("\n        " + _vm._s(_vm.content) + "\n        "),
      _vm.isAddnotationVisible
        ? _c("div", { staticClass: "gfu-media gfu-media--middle _mt-6" }, [
            _c("img", {
              staticClass: "_mr-3",
              attrs: {
                src: _vm.projectImageUrl,
                alt: _vm.projectName,
                height: "64",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-media__body" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$format(_vm.fundsGathered, "C0", "$"))),
              ]),
              _vm._v("\n                raised from "),
              _c("strong", [
                _vm._v(_vm._s(_vm.$format(_vm.backersCount, "N0"))),
              ]),
              _vm._v(
                "\n                backers during the crowdfunding campaign of " +
                  _vm._s(_vm.projectName) +
                  ".\n            "
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }